import AccountsStore from './AccountsStore';
import FavouritesStore from './FavouritesStore';
import UserManagementStore from '../UserManagementStore';
import envConfig from '../../../static/config';

/**
  SME users will now use FavouritesStore going forward, whereas retail users will continue to use the
  existing AccountsStore. This decision was made to minimize impact to the AccountStore and to
  retail by the SME LCV changes. The AccountStore was already bloated with too many responsibilities
  and adding favourites functionality had greater scope for regression.
  If the envConfig.isLcvEnabled is disabled (i.e. the feature is toggled off) then this module will
  simply export the exisiting AccountsStore and that will be used for both SME and Retail.
*/

const methods = Object.getOwnPropertyNames(
  Object.getPrototypeOf(AccountsStore)
).reduce((agg, curr) => {
  agg[curr] = (...args) => {
    if (!envConfig.isLcvEnabled) {
      return AccountsStore[curr](...args);
    }
    if (UserManagementStore.getUserDetailsLoad() && FavouritesStore.getLoad()) {
      if (
        UserManagementStore.isSMEUser() &&
        FavouritesStore.isLargeCustomer()
      ) {
        return FavouritesStore[curr](...args);
      }
      return AccountsStore[curr](...args);
    }
    return FavouritesStore[curr](...args);
  };
  return agg;
}, {});

export default methods;
